
import {
    useAbitAccountCreateMutation,
    useAbitAccountDestroyMutation,
    useAbitAccountsQuery,
    useAbitAccountUpdateMutation
} from "../query";
import {abitAccountMapper} from "../../../mapper/abitAccount";
import {useCallback, useState} from "react";
import {useFeedbackTools} from "../../../components/FeedbackTools";
import useDialog from "../../../hooks/useDialog";


const useAbitAccounts = () => {
    const abitAccountsQuery = useAbitAccountsQuery();
    const abitAccountCreateMutation = useAbitAccountCreateMutation();
    const abitAccountUpdateMutation = useAbitAccountUpdateMutation();
    const abitAccountDestroyMutation = useAbitAccountDestroyMutation();

    const isLoading = abitAccountsQuery.isLoading;
    const abitAccounts = abitAccountsQuery.data?.map(a => abitAccountMapper(a)) || [];

    const [selectedAccount, setSelectedAccount] = useState({});
    const {askConfirmation} = useFeedbackTools();
    const formCreate = useDialog();
    const formEdit = useDialog();

    const handleEditAccount = useCallback(
        (account) => {
            setSelectedAccount(account);
            formEdit.open();
        },
        [formEdit]
    )

    const handleDelete = useCallback(
        (e, accountId) => {
            e.stopPropagation();
            askConfirmation({
                title: "Eliminare Account",
                description: "Confermi di voler eliminare l'account?",
                confirmationText: 'Ok',
                cancellationText: 'cancella',
                onConfirm: async () => await abitAccountDestroyMutation.mutateAsync(accountId),
            })
        }, []  // eslint-disable-line react-hooks/exhaustive-deps
    )


    return {
        isLoading: isLoading,
        abitAccounts: abitAccounts,
        selectedAccount,
        handleEditAccount,
        handleDelete,
        createAbitAccount: abitAccountCreateMutation.mutateAsync,
        updateAbitAccount: abitAccountUpdateMutation.mutateAsync,
        destroyAbitAccount: abitAccountDestroyMutation.mutateAsync,
        isUpdating: abitAccountUpdateMutation.isLoading,
        isCreating: abitAccountCreateMutation.isLoading,
        isDestroying: abitAccountDestroyMutation.isLoading,
        formCreate,
        formEdit,
    }
}

export default useAbitAccounts;